import { LineItem } from './LineItem';

const TYPE = 'ShipOrder';

// TODO: Make sure this is right
export class ShipOrderLineItem extends LineItem {
  shipOrderId?: number;
  quantity?: number = 0;

  constructor(opts?: Partial<ShipOrderLineItem>) {
    super(opts);
    this.type = TYPE;

    if (opts?.shipOrderId != null) {
      this.shipOrderId = opts.shipOrderId;
    }
    if (opts?.quantity != null) {
      this.quantity = opts.quantity;
    }
  }

  static isShipOrderLineItem(
    lineItem: LineItem,
  ): lineItem is ShipOrderLineItem {
    return lineItem.type === TYPE;
  }
}
